import React from 'react'
import numeral from 'numeral'
import { OrderLineItemFragment } from '../../../../../fragments/OrderLineItem.generated'
import styles from './styles.css'

interface Props {
  lineItem: OrderLineItemFragment
  originalPrice: string | null
}

const ProductLineItemPrice: React.FC<Props> = ({ lineItem, originalPrice }) => {
  if (
    (!lineItem.parentId && !lineItem.isGroup) ||
    lineItem.source.__typename === 'OrderLineItemBasePriceSource'
  ) {
    return (
      <div className={styles.price} key={lineItem.id}>
        {lineItem.unitPrice.amount ? (
          numeral(lineItem.unitPrice.amount).format('$0,0.00')
        ) : (
          <span className={styles.free}>Free</span>
        )}
        {originalPrice && originalPrice > lineItem.unitPrice.amount && (
          <span className={styles.originalPrice}>{numeral(originalPrice).format('$0,0.00')}</span>
        )}
      </div>
    )
  } else {
    return (
      <div className={styles.customization} key={lineItem.id}>
        {`+ ${numeral(lineItem.price.amount).format('$0,0.00')} ${lineItem.title}`}
      </div>
    )
  }
}

export default ProductLineItemPrice
